import PropTypes from 'prop-types'
import { useState, useEffect } from 'react'
import { useAuth } from '../../../../context/AuthContext'
import Swal from 'sweetalert2';
import { settings } from '../../../../constants'
import sty from '../../WebCv/WebCv.module.css'
import { errorMessages } from '../../../../utils/messagesUtils'

const Works = ({ data }) => {
    Works.propTypes = {
		data: PropTypes.object.isRequired,
	}

    const { role } = useAuth()
	const [pdfUrl, setPdfUrl] = useState(null)
    const [path, setPath] = useState(null)

	// ポートフォリオのパス設定
    useEffect(() => {
        if (!data?.work_pdf?.filename) {
            return;
        }
        if (role == settings.MNG.ROLE || role == settings.ENGINEER.ROLE) {
            setPath(`${process.env.REACT_APP_API_BASE_URL}/work/portfolio/${data.work_pdf.filename}`)
        } else {
            setPath(`${process.env.REACT_APP_API_BASE_URL}/share/work/portfolio/${data.work_pdf.filename}`)
        }
    }, [role, data?.work_pdf?.filename])

	// ポートフォリオ取得
	const getPdfUrl = async (pdfData) => {
		if (!pdfData || !path) {
			return;
		}
		try {
			const response = await fetch(path,
				{
					method: 'GET',
					credentials: 'include',
					headers: {
						'Content-Type': 'application/json',
					},
				}
			)
			if (response.status === 200) {
				const blob = await response.blob()
				// 古いURLを無効化
				if (pdfUrl) {
					URL.revokeObjectURL(pdfUrl)
				}
				const newUrl = URL.createObjectURL(blob)
				setPdfUrl(newUrl)
			}else{
				const error = new Error();
				error.front_message = errorMessages.works.portfolio_fetch_failed;
				throw error;
			}
		} catch (e) {
			Swal.fire({
				icon: 'error',
				html: `<b>${e.front_message || errorMessages.api.server_error}</b>`
			});
		}
	}

	// 初期化
	useEffect(() => {
		if (data?.work_pdf && path) {
			getPdfUrl(data.work_pdf)
		}
		// コンポーネントのアンマウント時にURLを無効化
		return () => {
			if (pdfUrl) {
				URL.revokeObjectURL(pdfUrl)
			}
		}
	}, [data?.work_pdf, path])

	
	if (!data || (!data.work_pdf && !data.work_list)) {
		return <div>実績データがありません</div>
	}else{
		return (
			<div>
				<div className={sty['cv__works']}>
					{data.work_pdf && data.work_pdf_name ? (
						<dl className={sty['cv__works-list']}>
							<dt className={sty['cv__works-list-tit']}>
								{data.work_pdf_name}：
							</dt>
							<dd className={sty['cv__works-list-txt']}>
								<a
									href={pdfUrl || '#'}
									target="_blank"
									rel="noreferrer"
									className={sty['cv__works-list-link']}
									type="application/pdf"
								>
									PDFを表示
								</a>
							</dd>
						</dl>
					) : null}
					{data.work_list?.map((work, index) => (
						<dl className={sty['cv__works-list']} key={index}>
							<dt className={sty['cv__works-list-tit']}>
								{work.work_name}：
							</dt>
							<dd className={sty['cv__works-list-txt']}>
								<a
									href={work.work_url}
									target="_blank"
									rel="noreferrer"
									className={sty['cv__works-list-link']}
								>
									{work.work_url}
								</a>
							</dd>
						</dl>
					))}
				</div>
			</div>
		)
	}
}

export default Works
